/**
 * CRYO UNIFIED CART EVENT SYSTEM v3.1
 * ====================================
 * Simple debounced cart event dispatcher.
 * Only ONE /cart.js fetch fires after ALL mutations settle.
 */

(function() {
  'use strict';

  var originalFetch = window.fetch;
  var debounceTimer = null;

  window.fetch = function() {
    var args = arguments;
    return originalFetch.apply(this, args).then(function(response) {
      var url = typeof args[0] === 'string' ? args[0] : '';

      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          debounceTimer = null;
          originalFetch('/cart.js')
            .then(function(r) { return r.ok ? r.json() : null; })
            .then(function(cart) {
              if (cart) {
                document.dispatchEvent(new CustomEvent('cryo:cart:updated', {
                  detail: { cart: cart, action: 'update', timestamp: Date.now() }
                }));
              }
            })
            .catch(function() {});
        }, 1500);
      }

      return response;
    });
  };

  window.CryoCart = {
    refresh: function() {
      return originalFetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('cryo:cart:updated', {
            detail: { cart: cart, action: 'manual', timestamp: Date.now() }
          }));
          return cart;
        });
    },
    getCart: function() {
      return originalFetch('/cart.js').then(function(r) { return r.json(); });
    }
  };

  console.log('[CryoCart] Debounced cart system v3.1 initialized');
})();
